import {Parameter} from './Parameter';

export class Banking {
    dayOfMonth: Parameter = new Parameter('dayOfMonth');
    accountNumber: Parameter = new Parameter('accountNumber');
    routingNumber: Parameter = new Parameter('routingNumber');
    accountType: Parameter = new Parameter('accountType');
}
